import util from "@/common/util";
import { iInterface, iTest } from "@/services";

const CANDIDATES_LIMIT = 20;

const state = {
  testInfo: {
    id: -1,
    taskId: -1,
    interfaceId: -1,
    workType: "",
    startDate: "",
    candidateId: -1,
    evaluatorId: -1,
    evaluateDate: -1,
    fileBaseUrl: "",
    testStatus: "",
    manualUrl: "",
    progress: {
      completedCount: -1,
      rate: -1,
      totalCount: -1,
    },
    workable: false,
  },
  testItem: {
    id: -1,
    status: "",
    fileName: "",
    filePath: "",
    lastModifiedDate: "",
  },
  objects: [],
  selectedObjects: [],
  classes: [],
  canvasOption: {
    creating: false,
    doCopyNext: false,
    brightness: 50,
    contrast: 50,
    textSize: 10,
    lineSize: 1,
    pointSize: 4,
    crossline: false,
    gridline: 0,
    opacity: 25,
    gridlineSave: 10,
  },
  // ImageWidget State 시작
  testItems: [],
  pageInfo: {
    currentPage: -1,
    totalPage: -1,
    loading: false,
  },
  testItemListOptions: {
    filteredStatus: [],
    keyword: "",
    limit: 20,
    page: 1,
  },
  // ImageWidget State 종료
  // --- UI & Events State 시작 ---
  currentStatus: {
    loading: true,
    saving: false,
    isCandidate: true,
    gPointCurrentIdx: -1,
    selectedClass: {
      id: "",
      name: "",
      type: "",
      color: "",
      label: "",
    },
  },
  panelOpts: {
    left: {
      open: true,
      width: 300,
    },
    right: {
      open: true,
      width: 360,
    },
  },
  modal: {
    candidate: false,
    test: false,
    testType: "PASS",
  },
  // --- UI & Events State 종료 ---
  candidates: {
    submitterListItems: [],
    totalCount: -1,
    currentPage: 1,
    loading: false,
  },
  attrPointer: -1,
};

const mutations = {
  INITIALIZE_STATE: (state) => {
    console.log("@@ vuex state를 초기화하는 로직을 작성.", state);
  },
  SET_TESTSPACE_INFO: (state, data) => {
    state.testInfo.id = data.testId;
    state.testInfo.taskId = data.taskId;
    state.testInfo.interfaceId = data.interfaceId;
    state.testInfo.startDate = data.startDate;
    state.testInfo.candidateId = data.candidateId;
    state.testInfo.evaluatorId = data.evaluatorId;
    state.testInfo.evaluateDate = data.evaluateDate;
    state.testInfo.fileBaseUrl = data.fileBaseUrl;
    state.testInfo.manualUrl = data.manualUrl;
    state.testInfo.workType = data.candidateType;
    state.testInfo.testStatus = data.testStatus;
    state.testInfo.workable = data.workable;
    state.candidates.currentPage = data.page;
  },
  SET_TEST_ITEM: (state, data) => {
    state.testInfo.candidateId = data.candidateId;
    state.testItem.fileName = data.fileName;
    state.testItem.filePath = data.fileUrl;
    state.testItem.lastModifiedDate = data.lastModifiedDate;
    state.testItem.id = data.itemId;
    state.testItem.status = data.itemStatus;
  },
  SET_TEST_ITEM_ID: (state, data) => {
    state.testItem.id = data.itemId;
    state.testItem.status = data.testItemStatus;
  },
  // Testspace 상태 관련 Mutations 시작
  SET_LOADING: (state, data) => {
    state.currentStatus.loading = data.loading;
  },
  SET_SAVING: (state, data) => {
    state.currentStatus.saving = data.saving;
  },

  SET_IS_CANDIDATE: (state, data) => {
    state.currentStatus.isCandidate = data.isCandidate;
  },
  SET_CANDIDATES: (state, data) => {
    state.candidates.submitterListItems = data.submitterListItems;
    state.candidates.totalCount = data.totalCount;
  },
  SET_CANDIDATES_CURRENT_PAGE: (state, data) => {
    state.candidates.currentPage = data.page;
  },
  SET_SUBMITTERS_LOADING: (state, data) => {
    state.candidates.loading = data.loading;
  },
  // Testspace 상태 관련 Mutations 종료

  // Testspace Tools Option 관련 Mutations 시작
  SET_OPACITY: (state, data) => {
    state.canvasOption.opacity = data;
  },
  SET_DO_COPY_NEXT: (state, data) => {
    state.canvasOption.doCopyNext = data.doCopyNext;
  },
  SET_CONTRAST: (state, data) => {
    state.canvasOption.contrast = data;
  },
  SET_BRIGHTNESS: (state, data) => {
    state.canvasOption.brightness = data;
  },
  SET_TEXTSIZE: (state, data) => {
    state.canvasOption.textSize = data;
  },
  SET_LINESIZE: (state, data) => {
    state.canvasOption.lineSize = data;
  },
  SET_POINTSIZE: (state, data) => {
    state.canvasOption.pointSize = data;
  },
  SET_CROSSLINE: (state, data) => {
    state.canvasOption.crossline = data;
  },
  SET_GRIDLINE: (state, data) => {
    state.canvasOption.gridlineSave = state.canvasOption.gridline;
    state.canvasOption.gridline = data;
  },
  // Testspace Tools Option 관련 Mutations 종료

  // Testspace Object 관련 Mutations 시작
  SET_OBJECTS: (state, data) => {
    const OPTION_STATUS = {
      selected: false,
      open: false,
      visible: true,
      error: false,
    };

    const objects = util.importTaskResult(data.objects, state.classes);

    objects.map((obj) => {
      obj.currentStatus = structuredClone(OPTION_STATUS);

      const errors = util.checkObjectHasError(obj);
      const hasError = errors.attribute || errors.option;
      obj.currentStatus.error = hasError;

      obj.childrens.forEach((child) => {
        child.currentStatus = structuredClone(OPTION_STATUS);
      });

      if (obj.type === "GROUP_POINT") {
        obj = util.validateGroupPoint(obj);
      }
    });
    state.objects = objects;
  },
  ADD_OBJECT: (state, data) => {
    const exists = state.objects.map((obj) => obj.id).indexOf(data.object.id);
    if (exists !== -1) {
      return false;
    }
    state.objects.push(data.object);
  },
  ADD_OBJECTS: (state, data) => {
    data.objects.forEach((object) => {
      const exists = state.objects.map((obj) => obj.id).indexOf(object.id);
      if (exists !== -1) {
        return false;
      }
      state.objects.push(object);
    });
  },
  UPDATE_OBJECT_POINT: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const target = all.find((obj) => obj.id === data.id);
    if (!target) {
      return;
    }
    target.points = data.points;
  },
  REMOVE_OBJECT: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const target = all.find((obj) => obj.id === data.id);

    const targetIds = [target.parentId, data.id];
    state.objects = state.objects.filter((obj) => !targetIds.includes(obj.id));
  },
  REMOVE_ALL_OBJECT: (state) => {
    state.objects = [];
  },
  SET_OBJECT_SELECTED: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const object = all.find((obj) => obj.id === data.id);
    if (!object) {
      return;
    }
    object.currentStatus.selected = data.selected;

    if (data.selected && object.parentId) {
      const parent = all.find((obj) => obj.id === object.parentId);
      parent.currentStatus.open = true;
    }

    const selects = state.objects.filter((obj) => obj.currentStatus.selected);
    state.selectedObjects = selects;
  },
  SET_ALL_OBJECT_SELECTED: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    all.map((obj) => {
      obj.currentStatus.selected = data.selected;
    });

    const selects = state.objects.filter((obj) => obj.currentStatus.selected);
    state.selectedObjects = selects;
  },
  SET_OBJECT_VISIBLE: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const object = all.find((obj) => obj.id === data.id);
    if (!object) {
      return;
    }
    object.currentStatus.visible = data.visible;
  },
  SET_ALL_OBJECT_VISIBLE: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    all.map((obj) => {
      obj.currentStatus.visible = data.visible;
    });
  },
  UPDATE_OBJECT_CLASS: (state, data) => {
    const targetObj = data.object;
    const targetCls = data.class;

    targetCls.classId = targetCls.id;
    delete targetCls.id;

    state.objects = state.objects.map((obj) => {
      if (obj.id !== targetObj.id) {
        return obj;
      }
      return { ...obj, ...targetCls };
    });
  },
  SET_OBJECT_OPEN: (state, data) => {
    const all = state.objects.reduce((a, v) => [...a, v, ...v.childrens], []);
    const object = all.find((obj) => obj.id === data.id);
    if (!object) {
      return;
    }
    object.currentStatus.open = data.open;
  },
  SET_OBJECT_Z_ORDER: (state, { objects }) => {
    objects.forEach((object) => {
      const id = object.id;
      const zOrder = object.zOrder;
      const find = state.objects.find((obj) => obj.id === id);
      find.zOrder = zOrder;
      find.order = zOrder;
    });
  },
  // Testspace Object 관련 Mutations 종료

  // ClassWidget 관련 Mutations 시작
  SET_CLASSES: (state, data) => {
    const OPTION_STATUS = {
      label: true,
      count: 0,
      visible: true,
      selected: false,
      open: false,
      error: false,
    };

    data.map((cls) => {
      cls.currentStatus = structuredClone(OPTION_STATUS);
      const children = [];
      cls.childrens.forEach((child) => {
        const copyCnt = child.endIndex - child.startIndex + 1;
        for (let i = 0; i < copyCnt; i++) {
          const tmp = structuredClone(child);
          tmp.attributes = cls.attributes;
          tmp.currentStatus = OPTION_STATUS;
          children.push(structuredClone(tmp));
        }
      });
      cls.childrens = children;
    });

    state.classes = data;
  },
  SET_CLASS_SELECTED: (state, data) => {
    state.classes.map((cls) => (cls.currentStatus.selected = false));
    const cls = state.classes.find((cls) => cls.id === data.id);

    cls.currentStatus.selected = data.selected;
    if (!data.selected) {
      state.currentStatus.selectedClass.id = "";
      state.currentStatus.selectedClass.name = "";
      state.currentStatus.selectedClass.type = "";
      state.currentStatus.selectedClass.color = "";
      state.currentStatus.selectedClass.label = "";
      state.currentStatus.selectedClass.options = [];
      return;
    }
    state.currentStatus.selectedClass.id = cls.id;
    state.currentStatus.selectedClass.name = cls.name;
    state.currentStatus.selectedClass.type = cls.type;
    state.currentStatus.selectedClass.color = cls.color;
    state.currentStatus.selectedClass.label = cls.currentStatus.label;
    state.currentStatus.selectedClass.options = cls.options;
  },
  SET_CLASS_VISIBLE: (state, data) => {
    const classes = state.classes;
    const cls = classes.find((cls) => cls.id === data.id);
    cls.currentStatus.visible = data.visible;
  },
  SET_CLASS_LABEL: (state, data) => {
    const cls = state.classes.find((cls) => cls.id === data.id);
    cls.currentStatus.label = data.label;

    if (cls.id === state.currentStatus.selectedClass.id) {
      state.currentStatus.selectedClass.label = cls.currentStatus.label;
    }
  },
  SET_GROUP_POINT_POINTER: (state, data) => {
    state.currentStatus.gPointCurrentIdx = data.idx;
  },
  // ClassWidget 관련 Mutations 종료

  // ImageWidget 관련 Mutations 시작
  SET_PAGE_INFO: (state, data) => {
    state.testItemListOptions.page = data.currentPage;
    state.pageInfo.currentPage = data.currentPage;
    state.pageInfo.totalPage = data.totalPage;
  },
  SET_TESTITEMS: (state, data) => {
    state.testItems = data.testItems.map((item) => {
      return {
        id: item.itemId,
        name: item.fileName,
        status: item.testItemStatus,
      };
    });
  },
  SET_TESTITEMS_OPTS_KEYWORD: (state, data) => {
    state.testItemListOptions.keyword = data.keyword;
  },
  SET_TESTITEMS_OPTS_PAGE: (state, data) => {
    state.testItemListOptions.page = data.page;
  },
  SET_TESTITEMS_OPTS_STATUS: (state, data) => {
    state.testItemListOptions.filteredStatus = data.statuses;
  },
  SET_TESTITEMS_PAGE_LOADING: (state, data) => {
    state.pageInfo.loading = data.loading;
  },
  // ImageWidget 관련 Mutations 종료

  // ObjectWidget 관련 Mutations 시작
  SET_ATTRIBUTE_POINTER: (state, data) => {
    state.attrPointer = data;
  },
  // ObjectWidget 관련 Mutations 종료

  // testspace 주변 UI 관련 Mutations 시작
  SET_LEFT_PANEL_OPTS: (state, data) => {
    state.panelOpts.left.open = data.open;
    state.panelOpts.left.width = data.width;
  },
  SET_RIGHT_PANEL_OPTS: (state, data) => {
    state.panelOpts.right.open = data.open;
    state.panelOpts.right.width = data.width;
  },
  SET_CONTROL_OPEN: (state, data) => {
    state.canvasOption.controlOpen = data;
  },

  SET_IS_CANDIDATE_MODAL_OPEN: (state, data) => {
    state.modal.candidate = data.open;
  },
  SET_TEST_MODAL_OPEN: (state, data) => {
    state.modal.test = data.open;
    state.modal.testType = data.type || "PASS";
  },
  SET_PROGRESS: (state, data) => {
    state.testInfo.progress = data;
  },
  // testspace 주변 UI 관련 Mutations 종료
};

const actions = {
  async setTestspaceInfo({ state, commit }, payload) {
    const info = await iTest.getTestInfo({
      ...payload,
      limit: CANDIDATES_LIMIT,
    });
    if (info.data?.code !== "") {
      console.log("[Error] while get TestInfo : ", info.data?.code);
      return false;
    }

    commit("SET_TESTSPACE_INFO", info.data.payload);

    // Interface (classes) 데이터 로드
    const id = state.testInfo.interfaceId;
    const inf = await iInterface.getInterfaceDetail({ id });
    if (inf.data?.code !== "") {
      return false;
    }

    const classData = inf.data.payload.classData.map((cls) => {
      const ret = { ...cls, ...cls.data };
      ret.childrens = ret.children || [];
      delete ret.children;
      delete ret.data;
      return ret;
    });
    commit("SET_CLASSES", classData);
    return true;
  },
  // 테스트 아이템 목록 데이터를 로드
  async setTestItems({ state, commit, dispatch }, fixPage = -1) {
    const payload = {
      testItemId: state.testItem.id,
      filteredStatus: state.testItemListOptions.filteredStatus.join(","),
      keyword: state.testItemListOptions.keyword,
      limit: state.testItemListOptions.limit,
    };

    await dispatch("setPageInfo", { payload, fixPage });
    payload.page = fixPage > -1 ? fixPage : state.testItemListOptions.page;

    const items = await iTest.getTestItems(payload);
    if (items.data?.code !== "") {
      console.log("[Error] while get test items : ", items.data?.code);
      return false;
    }

    commit("SET_TESTITEMS", { testItems: items.data.payload });

    if (state.currentStatus.isCandidate) {
      await dispatch("setProgress");
    }
    return true;
  },
  // 테스트 아이템 목록 페이지 데이터를 로드
  async setPageInfo({ commit }, data) {
    const res = await iTest.getTestPageInfo(data.payload);
    if (res.data?.code) {
      console.log("[Error] while get page info", res.data?.code);
      return false;
    }

    let result = res.data.payload;
    result.currentPage = data.fixPage > -1 ? data.fixPage : result.currentPage;
    commit("SET_PAGE_INFO", result);
    return true;
  },
  // TestItem의 Id와 Status를 state에 저장하고 반환하는 매서드
  async getTestItemId({ state, commit }, payload) {
    const testItemId = payload.testItemId || null;
    const testId = testItemId ? null : payload.testId || state.testInfo.id;
    const nextCond = payload.nextCond || "P";
    const order = payload.order || "ASC";

    const testItemIdPayload = {
      ...state.testItemListOptions,
      testId,
      testItemId,
      nextCond,
      order,
    };
    const itemIdRes = await iTest.getTestItemId(testItemIdPayload);
    const itemId = itemIdRes.data?.payload?.itemId;
    if (itemIdRes.data?.code !== "") {
      console.log("[Error] while get testItemId", itemIdRes.data?.code);
      return -1;
    }

    if (itemId === undefined) {
      return -1;
    }

    commit("SET_TEST_ITEM_ID", itemIdRes.data.payload);
    return itemId;
  },
  // testItem 데이터를 state에 저장하는 메서드
  async setTestItem({ state, commit }, payload = {}) {
    const testItemId = payload.testItemId || state.testItem.id;
    const res = await iTest.getTestItemInfo({ testItemId });
    if (res.data?.code !== "") {
      return false;
    }

    commit("SET_TEST_ITEM", res.data.payload);

    commit("SET_OBJECTS", { objects: res.data.payload?.objects });
    return res.data.payload;
  },
  // 서버로 objects를 저장하는 메서드
  async saveAnswer({ commit, state, dispatch }, data = {}) {
    commit("SET_SAVING", { saving: true });
    const objects = util.exportTaskResult(
      data.objects || state.objects,
      state.classes
    );

    const payload = {
      testItemId: data.testItemId || state.testItem.id,
      answer: objects,
    };

    const res = await iTest.setSaveTestItem(payload);
    if (res.data?.code !== "") {
      commit("SET_WORKSPACE_SAVING", { saving: false });
      return res.data.code;
    }

    if (res.data.payload.itemStatus !== state.testItem.status) {
      await dispatch("setTestItems");
      await dispatch("setCurrentItemStatus");
    }

    commit("SET_SAVING", { saving: false });
    return res.data.code;
  },
  // 현재 보고 있는 testItem의 status를 갱신 함
  async setCurrentItemStatus({ state, commit }) {
    const testItemId = state.testItem.id;
    const res = await iTest.getTestItemInfo({ testItemId });
    if (res.data?.code !== "") {
      return false;
    }

    const payload = {
      itemId: res.data.payload.itemId,
      testItemStatus: res.data.payload.itemStatus,
    };
    commit("SET_TEST_ITEM_ID", payload);
  },
  async execute({ state }, payload) {
    payload = {
      testItemId: state.testItem.id,
      submitType: payload.submitType,
    };

    const res = await iTest.setTestItemStatus(payload);
    if (res.data.code === "TK0001") {
      return res.data.code;
    }

    if (res.data.code === "TK0003") {
      return res.data.code;
    }

    if (["W0002", "W0003"].includes(res.data.code)) {
      return res.data.code;
    }

    return res.data.code;
  },
  async submit({ state }, payload) {
    payload = [
      {
        modifiedStatus: payload.modifiedStatus,
        testId: state.testInfo.id,
      },
    ];

    const res = await iTest.setTestsStatus(payload);
    if (res.data?.code !== "") {
      return false;
    }

    return true;
  },

  async setCandidates({ state, commit }, payload) {
    payload = {
      limit: CANDIDATES_LIMIT,
      taskId: state.testInfo.taskId,
      page: payload.page || state.candidates.currentPage,
      submitterType: payload.submitterType || "O",
    };

    if (payload.page) {
      commit("SET_CANDIDATES_CURRENT_PAGE", { page: payload.page });
    }

    const res = await iTest.getTestSubmitters(payload);
    if (res.data?.code !== "") {
      return false;
    }

    commit("SET_CANDIDATES", res.data.payload);
    return true;
  },
  async setProgress({ state, commit }) {
    const payload = { testId: state.testInfo.id };
    const res = await iTest.getTestProgress(payload);
    if (res.data?.code !== "") {
      return false;
    }

    commit("SET_PROGRESS", res.data.payload);
    return true;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
